import React from "react";
import { cn } from "../utils";
import { Panel } from "../panel";

export function DataPanel({ toolbar, children, className, rounded = "sm" }) {
  return (
    <Panel rounded={rounded} shadow padding="none" className={className}>
      {toolbar && (
        <div className="flex items-center justify-between px-5 pt-5 pb-3 border-b border-gray-100">
          {toolbar}
        </div>
      )}
      <div className="overflow-x-auto">{children}</div>
    </Panel>
  );
}

export function ToolbarActions({ children, className }) {
  return <div className={cn("flex items-center gap-2", className)}>{children}</div>;
}
